import React from 'react'
import cx from 'classnames'
import * as Icon from '@manychat/icons'

import * as l from '../../utils/localization/format'

import { IconNames, TabProps } from './interfaces'

import cm from './Tabs.module.css'

export const Tab = <T,>({
  value,
  options,
  onClick,
  tabOption,
  tabIndex,
  ariaControls,
}: TabProps<T>) => {
  const isActive = tabOption.value === value
  const TabIcon = tabOption.icon && Icon[tabOption.icon as IconNames]

  const renderTabLabel = (label: string | (() => React.ReactNode) | JSX.Element) => {
    if (typeof label === 'string') {
      return <span>{label}</span>
    } else if (typeof label === 'function') {
      return l.getString(label as ReturnType<typeof l.makeTranslate>)
    } else {
      return label
    }
  }

  const tabClassName = cx('tap-highlight-none', cm.tab, {
    [cm.first]: tabIndex === 0,
    [cm.last]: tabIndex === options.length - 1,
    [cm.active]: isActive,
    [cm.icon]: tabOption.icon !== undefined,
  })

  return (
    <li
      role="presentation"
      data-active={isActive ? 'active' : ''}
      data-disabled={tabOption.disabled || false}
      className={cm.tabContainer}
    >
      <button
        role="tab"
        id={tabOption.id}
        aria-selected={isActive}
        aria-disabled={tabOption.disabled || false}
        disabled={tabOption.disabled}
        aria-controls={ariaControls}
        data-test-id={tabOption['data-test-id']}
        onClick={!tabOption.disabled ? () => onClick?.(tabOption.value, tabIndex) : undefined}
        className={tabClassName}
      >
        {TabIcon && <TabIcon aria-hidden="true" size={24} />}
        {renderTabLabel(tabOption.label)}
      </button>
    </li>
  )
}
